module.exports = __webpack_public_path__ + "static/media/k-12-landscape.4f44666d.jpg";